import { Routes } from '@angular/router';

import { mpsRoutes } from './mps/routes/mps.routes';
import { applicationRoutes } from './app/application.routes';

export const globalRoutes: Routes = [
  ...mpsRoutes,
  ...applicationRoutes,
];
